module.exports = __webpack_public_path__ + "static/media/Laura Santini Headshot_1696339817746.597b2a2a.jpeg";